// @flow
import { createContext } from 'react';
import type { Context } from 'react';

type AdaptiveContextType = {
  device: 'tablet' | 'mobile' | 'desktop',
  isMobile: boolean,
  isTablet: boolean,
  isWebView: boolean,
  isBot: boolean,
  userAgent: string,
};

export const AdaptiveContext: Context<AdaptiveContextType> = createContext({
  device: 'desktop',
  isMobile: false,
  isTablet: false,
  isWebView: false,
  isBot: false,
  userAgent: '',
});
